import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaChartLine, FaArrowTrendUp, FaChevronDown, FaChevronUp } from 'react-icons/fa6';
import { IoMdSettings } from 'react-icons/io';
import { MdLogout } from "react-icons/md";
import { FaHistory, FaUserPlus } from 'react-icons/fa';
import Swal from "sweetalert2";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAgentDropdownOpen, setIsAgentDropdownOpen] = useState(false);

  const alertAndRoute = () => {
    Swal.fire({
      title: "Logout",
      text: "Are you sure you want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#57A43F",
      confirmButtonText: "Logout",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        navigate("/login");
      }
    });
  };
  
  
  const isActiveRoute = (path) => location.pathname === path;
  return (
    <aside
      className={`bg-white border-r-2 border-slate-200 h-full fixed sm:top-[15px] z-50 w-64 transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : '-translate-x-full'
        } sm:translate-x-0`}
    >
      <div className='flex flex-col h-full'>
        <nav className='w-full'>
          <ul className='p-3'>

            {[
              { to: '/dashboard', label: 'Dashboard', icon: <FaChartLine /> },
              { to: '/escalations', label: 'Escalations', icon: <FaArrowTrendUp /> },
              { to: '/chat-history', label: 'Chat History', icon: <FaHistory /> },
            ].map(({ to, label, icon }) => {
              const isActive = isActiveRoute(to);

              return (
                <Link to={to} key={to}>
                  <li
                    className={`group p-3 my-3 rounded-lg flex items-center gap-4 cursor-pointer ${isActive ? 'bg-green text-white' : 'hover:bg-green'
                      }`}
                    onClick={toggleSidebar}
                  >
                    <div className={` ${isActive ? 'text-white' : 'text-gray-600 group-hover:text-white'}`}>{icon}</div>
                    <div className={`${isActive ? 'text-white' : 'text-gray-700 group-hover:text-white'}`}>{label}</div>
                  </li>
                </Link>
              );
            })}

            {/* Agent Dropdown */}
            <li className='my-3'>
              <button
                onClick={() => setIsAgentDropdownOpen(!isAgentDropdownOpen)}
                className="w-full group p-3 rounded-lg flex justify-between items-center gap-4 cursor-pointer hover:bg-green text-gray-700 hover:text-white transition-colors"
              >
                <div className="flex items-center gap-4">
                  <FaUserPlus className="text-gray-600 group-hover:text-white" />
                  <span className="group-hover:text-white">Agent</span>
                </div>
                {isAgentDropdownOpen ? <FaChevronUp className="group-hover:text-white" /> : <FaChevronDown className="group-hover:text-white" />}
              </button>

              {isAgentDropdownOpen && (
                <ul className="ml-8 my-3">
                  <Link to="/agents" onClick={toggleSidebar}>
                    <li className={`p-2 rounded-lg cursor-pointer my-3 ${isActiveRoute('/agents') ? 'bg-green text-white' : 'hover:bg-green hover:text-white text-gray-700'}`}>
                      Agents
                    </li>
                  </Link>
                  <Link to="/add-agent" onClick={toggleSidebar}>
                    <li className={`p-2 rounded-lg cursor-pointer my-3 ${isActiveRoute('/add-agent') ? 'bg-green text-white' : 'hover:bg-green hover:text-white text-gray-700'}`}>
                      Add Agent
                    </li>
                  </Link>
                </ul>
              )}
            </li>

            {/* Settings */}
            <Link to="/settings">
              <li
                className={`group p-3 my-3 rounded-lg flex items-center gap-4 cursor-pointer ${isActiveRoute('/settings') ? 'bg-green text-white' : 'hover:bg-green'
                  }`}
                onClick={toggleSidebar}
              >
                <IoMdSettings className={`${isActiveRoute('/settings') ? 'text-white' : 'text-gray-600 group-hover:text-white'}`} />
                <span className={`${isActiveRoute('/settings') ? 'text-white' : 'text-gray-700 group-hover:text-white'}`}>Settings</span>
              </li>
            </Link>
          </ul>
        </nav>

        {/* Logout */}
        <div className="p-3 w-full border-t border-gray-200">
          <button
            onClick={alertAndRoute}
            className="group flex w-full p-3 rounded-lg text-gray-600 hover:bg-green hover:text-white transition-colors"
          >
            <MdLogout className="mr-3 text-gray-700 group-hover:text-white" />
            Logout
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
